export default function Hero() {
  return <section id="hero" className="bg-background py-24 md:py-32 lg:py-48 flex items-center justify-center text-center border-b border-border/30">
      <div className="container max-w-4xl px-4 md:px-6 flex flex-col items-center gap-6 md:gap-8">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-default font-bold tracking-widest text-foreground uppercase">
          Solid Green Italia
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl font-default leading-relaxed">
          Rivenditore ufficiale per l'Italia delle tecnologie Solid Dew. Promuoviamo l'agricoltura sostenibile attraverso soluzioni avanzate per il risparmio idrico e la salute del suolo.
        </p>
      </div>
    </section>;
}